<template>
	<div id="app" @click="clicked">
		<router-view />
	</div>
</template>
<script>
export default {
	data() {
		return {
			lTime: new Date().getTime(), // 最后一次点击的时间
			// tOut: 60 * 10 * 1000,   //超时时间10min
			tOut: 2 * 60 * 60 * 1000,
			t1: '',

			gap_time: 0,
			beforeUnload_time: 0,
		}
	},
	mounted() {
		// 监听页面关闭，执行退出操作
		window.addEventListener('beforeunload', () => this.beforeunloadHandler())
		window.addEventListener('unload', (e) => {
			console.log('unload')
			this.unloadHandler(e)
		})
	},
	methods: {
		beforeunloadHandler() {
			this.beforeUnload_time = new Date().getTime()
		},
		// 账号退出
		unloadHandler() {
			this.gap_time = new Date().getTime() - this.beforeUnload_time
			//判断是窗口关闭还是刷新 毫秒数判断 网上大部分写的是5
			if (this.gap_time <= 2) {
				this.logOut() // 退出登录接口 这里应当换为个人的登出方法
			} else {
			}
		},

		logOut() {
			window.localStorage.removeItem('wlwtoken')
			window.localStorage.removeItem('wlwuserName')
			let users = this.getItem('wlwUser')
			let userInfo = this.getItem('wlwUserInfo')
			let orgs = this.getItem('wlwOrg')
			if (users) {
				window.localStorage.removeItem('wlwUser')
			}
			if (userInfo) {
				window.localStorage.removeItem('wlwUserInfo')
			}
			if (orgs) {
				window.localStorage.removeItem('wlwOrg')
			}
			window.localStorage.clear()
		},

		// 页面点击事件
		clicked() {
			let nowTime = new Date().getTime()
			if (nowTime - this.lTime > this.tOut) {
				//未登录状态
				if (localStorage.getItem('wlwtoken') == undefined) {
					this.lTime = new Date().getTime()
				} else {
					this.logOut()
					this.$message('登录超时，请重新登录', 'error')
					setTimeout(() => {
						this.$router.push('/login')
					}, 1000)
				}
			}
		},
	},
	// 移除页面监听
	destroyed() {
		window.removeEventListener('beforeunload', () => this.beforeunloadHandler())
		window.removeEventListener('unload', (e) => {
			this.unloadHandler(e)
		})
	},
}
</script>

<style lang="scss">
@import './assets/fonts/font.css';
@import './assets/css/global.scss';
@import '@/assets/css/formtable.scss';
html,
body,
#app {
	width: 100%;
	height: 100%;
	min-width: 1300px;
	min-height: 100%;
}
</style>
